// ActivityItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import { DragSource as dragSource, DropTarget as dropTarget } from 'react-dnd'
import classnames from 'classnames'
import _ from 'lodash'

import IconButton from '../../../common/icon_button/icon_button.jsx'
import ActionAdd from '../action_add/action_add.jsx'
import currency from '../../../../lib/currency.jsx'
import IntlUtil from '../../../../lib/intlutil.jsx'
import InlineInput from '../../../common/inline_input/inline_input.jsx'
import IntlMessage from '../../../../common/common/intl/intl_message.jsx'
import FormRateCardAutoComplete from '../../../../common/form/ratecard_auto_complete/ratecard_auto_complete.jsx'

const itemSource = {
  beginDrag (props, _monitor) {
    const { item, activeFilters, canEdit, columnOptions } = props

    item.orgPhaseId = item.phaseId
    item.orgIndex = props.getItemPosition(item.id)

    return {
      dragItemType: 'activity',
      item,
      columnOptions,
      activeFilters,
      canEdit
    }
  },
  endDrag (props, monitor) {
    const { item } = monitor.getItem()
    const didDrop = monitor.didDrop()

    if (!didDrop && props.onMoveItem) {
      props.onMoveItem(item.phaseId, item.orgPhaseId, null, item, item.orgIndex)
    }

    if (props.onDragEnd) {
      props.onDragEnd()
    }
  }
}

const itemTarget = {
  hover (props, monitor, component) {
    const { item, dragItemType } = monitor.getItem()

    if (dragItemType === 'activity') {
      const overId = props.item.id

      const currentPos = props.getItemPosition(item.id)
      const overPos = props.getItemPosition(overId)

      const boundingRect = ReactDOM.findDOMNode(
        component
      ).getBoundingClientRect()
      const clientOffset = monitor.getClientOffset()
      const ownMiddleY = boundingRect.bottom - boundingRect.top
      const offsetY = clientOffset.y - boundingRect.top

      if (currentPos < overPos && offsetY < ownMiddleY - 20) {
        return
      }

      if (currentPos > overPos && offsetY > 20) {
        return
      }

      if (props.onMoveItem && item.id !== overId) {
        props.onMoveItem(item.phaseId, props.item.phaseId, overId, item, null)
      }
    }
  }
}

class ActivityItem extends Component {
  static get propTypes () {
    return {
      item: PropTypes.object,
      canEdit: PropTypes.bool,
      onAdd: PropTypes.func,
      onDelete: PropTypes.func,
      onEdit: PropTypes.func,
      onDrag: PropTypes.func,
      onChange: PropTypes.func,
      onSave: PropTypes.func,
      onSelectRatecard: PropTypes.func,
      onKeyDown: PropTypes.func,
      onAddActivity: PropTypes.func,
      onClickEdit: PropTypes.func,
      activeFilters: PropTypes.array,
      rateCards: PropTypes.array,
      connectDragSource: PropTypes.func,
      connectDragPreview: PropTypes.func,
      connectDropTarget: PropTypes.func,
      dragItem: PropTypes.object,
      columnOptions: PropTypes.array
    }
  }

  static get defaultProps () {
    return {
      item: null,
      canEdit: false,
      onAdd: null,
      onDelete: null,
      onEdit: null,
      onDrag: null,
      onChange: null,
      onSave: null,
      onSelectRatecard: null,
      onKeyDown: null,
      onAddActivity: null,
      onClickEdit: null,
      activeFilters: [],
      rateCards: [],
      connectDragSource: null,
      connectDragPreview: null,
      connectDropTarget: null,
      dragItem: null,
      columnOptions: []
    }
  }

  _renderCustomColumnInputs () {
    const { columnOptions } = this.props
    const columnsRenders = {
      budget: this._renderBudgetInput,
      spent: this._renderSpentInput,
      sales: this._renderSellingPriceInput
    }

    const columnsEnabled = []
    if (columnOptions) {
      columnOptions.forEach(column => {
        if (!column.disabled && column.selected) {
          columnsEnabled.push(column.ident)
        }
      })
    }

    return columnsEnabled.map(column => {
      const renderFn = columnsRenders[column]
      return renderFn()
    })
  }

  _renderBudgetInput = () => {
    const { item, canEdit } = this.props
    return (
      <div className='col budget'>
        <InlineInput
          value={`${item.total}`}
          displayValue={currency.formatSymbol(item.total)}
          showInput={item.editable === 'total'}
          canEdit={canEdit}
          inputType='input'
          placeholder='project.viewBudget.priceDefault'
          onChange={this._onChangeInput.bind(this, 'total')}
          onBlur={this._onBlurInput.bind(this, 'total')}
          onKeyDown={this._onKeyDownInput.bind(this, 'total')}
          onClickEdit={this._onClickEditInput.bind(this, 'total')}
        />
      </div>
    )
  }

  _renderSpentInput = () => {
    const { item } = this.props
    return (
      <div className='col spent'>
        <div
          className={`percentage ${item.percentage > 100 ? 'haserror' : ''}`}
        >
          {item.percentage > 0 ? item.percentage + ' %' : ''}
        </div>
        <div className='amount'>{currency.formatSymbol(item.spentAmount)}</div>
      </div>
    )
  }

  _renderSellingPriceInput = () => {
    const { item, canEdit } = this.props
    if (item.type !== 'expense-activity') {
      return (
        <div className='col sales'>
          <div className='amount'>&nbsp;</div>
        </div>
      )
    }

    return (
      <div className='col sales'>
        <InlineInput
          value={`${item.sellingPrice}`}
          displayValue={currency.formatSymbol(item.sellingPrice)}
          showInput={item.editable === 'sellingPrice'}
          canEdit={canEdit}
          inputType='input'
          placeholder='project.viewBudget.labelSellingPrice'
          onChange={this._onChangeInput.bind(this, 'sellingPrice')}
          onBlur={this._onBlurInput.bind(this, 'sellingPrice')}
          onKeyDown={this._onKeyDownInput.bind(this, 'sellingPrice')}
          onClickEdit={this._onClickEditInput.bind(this, 'sellingPrice')}
        />
      </div>
    )
  }

  render () {
    const { item, canEdit } = this.props
    let activityIcon = ''
    const connectDragSource =
      this.props.connectDragSource || this._defaultDragRender
    const connectDragPreview =
      this.props.connectDragPreview || this._defaultDragRender
    const connectDropTarget =
      this.props.connectDropTarget || this._defaultDragRender

    if (item.type === 'time-activity') {
      activityIcon = 'timer'
    } else if (item.type === 'expense-activity') {
      if (currency.getCurrency() === 'USD') {
        activityIcon = 'dollar'
      } else if (currency.getCurrency() === 'GBP') {
        activityIcon = 'pound'
      } else {
        activityIcon = 'euro'
      }
    } else if (item.type === 'text') {
      return this._renderTextActivity()
    }

    let displayPriceLabel = ''
    let displayHoursLabel = ''

    if (item.type === 'time-activity') {
      displayPriceLabel =
        currency.formatSymbol(item.pricePerHour) +
        ' ' +
        IntlUtil.convertMessage('project.viewBudget.timePricePerUnit')
    } else {
      displayPriceLabel = currency.formatSymbol(item.pricePerHour)
    }

    if (item.type === 'expense-activity') {
      displayHoursLabel =
        currency.format(item.noHours) +
        ' ' +
        IntlUtil.convertMessage('project.viewBudget.unitForExpense')
    } else {
      displayHoursLabel = currency.format(item.noHours)
    }

    return connectDragPreview(
      connectDropTarget(
        <div
          className={classnames('activity-item', 'activity-item-text', {
            isdragging: this._isDragging(),
            disabled: !canEdit
          })}
        >
          {this._renderActivityAdd()}
          <div className='activity-item-content'>
            <div className='col select'>
              {item.canDelete ? (
                <div className='col actionclose'>
                  <IconButton
                    icon='x'
                    type='error'
                    canHover
                    size='small'
                    onClick={this._onDeleteActivity.bind(this)}
                  />
                </div>
              ) : (
                <div className='timecardaction' />
              )}
              <div className='col imagecont'>
                <IconButton
                  icon={activityIcon}
                  iconSize={activityIcon === 'euro' ? '24' : '10'}
                  type='transparent'
                  hasBorder
                  className={activityIcon === 'timer' ? 'timericon' : ''}
                />
              </div>
            </div>
            <div className='col title'>
              {item.type === 'time-activity' ? (
                <InlineInput
                  value={item.title}
                  showInput={item.editable === 'title'}
                  canEdit={canEdit}
                  inputType='custom'
                  placeholder='project.viewBudget.timeActivity'
                  onClickEdit={this._onClickEditInput.bind(this, 'title')}
                  onRenderInput={this._renderRatecardAutoComplete} // eslint-disable-line react/jsx-handler-names
                />
              ) : (
                <InlineInput
                  value={item.title}
                  showInput={item.editable === 'title'}
                  canEdit={canEdit}
                  inputType='input'
                  placeholder='project.viewBudget.newExpense'
                  onChange={this._onChangeInput.bind(this, 'title')}
                  onBlur={this._onBlurInput.bind(this, 'title')}
                  onKeyDown={this._onKeyDownInput.bind(this, 'title')}
                  onClickEdit={this._onClickEditInput.bind(this, 'title')}
                />
              )}
            </div>
            {item.bUseTotal ? (
              <div className='col labeltotalprice'>
                <div
                  className='label'
                  onClick={this._onClickEditInput.bind(this, 'bUseTotal')}
                >
                  <IntlMessage ident='project.viewBudget.totalPriceInfo' />
                </div>
              </div>
            ) : (
              <>
                <div className='col hours'>
                  <InlineInput
                    value={item.noHours}
                    displayValue={displayHoursLabel || currency.format(0)}
                    showInput={item.editable === 'noHours'}
                    canEdit={canEdit}
                    inputType='input'
                    placeholder='project.viewBudget.selectedHours'
                    onChange={this._onChangeInput.bind(this, 'noHours')}
                    onBlur={this._onBlurInput.bind(this, 'noHours')}
                    onKeyDown={this._onKeyDownInput.bind(this, 'noHours')}
                    onClickEdit={this._onClickEditInput.bind(this, 'noHours')}
                  />
                </div>
                <div className='col price'>
                  <InlineInput
                    value={item.pricePerHour}
                    displayValue={displayPriceLabel}
                    showInput={item.editable === 'pricePerHour'}
                    canEdit={canEdit}
                    inputType='input'
                    placeholder='project.viewBudget.pricePerHours'
                    onChange={this._onChangeInput.bind(this, 'pricePerHour')}
                    onBlur={this._onBlurInput.bind(this, 'pricePerHour')}
                    onKeyDown={this._onKeyDownInput.bind(this, 'pricePerHour')}
                    onClickEdit={this._onClickEditInput.bind(
                      this,
                      'pricePerHour'
                    )}
                  />
                </div>
              </>
            )}
            {this._renderCustomColumnInputs()}
            <div className='col actions'>
              {canEdit && (
                <>
                  <IconButton
                    icon='edit'
                    type='secondary'
                    className='actbutton'
                    canHover
                    onClick={this._onEditActivity.bind(this)}
                  />
                  {connectDragSource(
                    <div className='dragaction'>
                      <IconButton
                        icon='drag'
                        iconSize='26'
                        className='dragbutton'
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )
    )
  }

  _renderTextActivity () {
    const { item, canEdit } = this.props
    const connectDragSource =
      this.props.connectDragSource || this._defaultDragRender
    const connectDragPreview =
      this.props.connectDragPreview || this._defaultDragRender
    const connectDropTarget =
      this.props.connectDropTarget || this._defaultDragRender

    return connectDragPreview(
      connectDropTarget(
        <div
          className={classnames('activity-item', 'activity-item-text', {
            isdragging: this._isDragging(),
            disabled: !canEdit
          })}
        >
          {this._renderActivityAdd()}
          <div className='activity-item-content'>
            <div className='col select'>
              <div className='col actionclose'>
                <IconButton
                  icon='x'
                  type='error'
                  canHover
                  size='small'
                  onClick={this._onDeleteActivity.bind(this)}
                />
              </div>
              <div className='col imagecont'>
                <IconButton
                  icon='text'
                  iconSize='24'
                  type='transparent'
                  hasBorder
                />
              </div>
            </div>
            <div className='col title'>
              <InlineInput
                value={item.title}
                showInput={item.editable === 'title'}
                canEdit={canEdit}
                inputType='textarea'
                placeholder='title'
                onChange={this._onChangeInput.bind(this, 'title')}
                onBlur={this._onBlurInput.bind(this, 'title')}
                onKeyDown={this._onKeyDownInput.bind(this, 'title')}
                onClickEdit={this._onClickEditInput.bind(this, 'title')}
              />
            </div>
            <div className='col actions'>
              {canEdit && (
                <>
                  {connectDragSource(
                    <div className='dragaction'>
                      <IconButton
                        icon='drag'
                        iconSize='26'
                        className='dragbutton'
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )
    )
  }

  _renderActivityAdd () {
    const { activeFilters, canEdit } = this.props

    if (!canEdit) {
      return null
    }

    return (
      <ActionAdd
        showLabel={false}
        activeFilters={activeFilters}
        onAddActivity={this._onAddActivity} // eslint-disable-line react/jsx-handler-names
      />
    )
  }

  _renderRatecardAutoComplete = () => {
    const { item } = this.props

    let options = this.props.rateCards
    if (item.title) {
      options = []

      const keyword = item.title.toLowerCase()

      for (const pOpt of this.props.rateCards) {
        const value = pOpt.value ? pOpt.value.toLowerCase() : ''
        if (value && value.includes(keyword)) {
          options.push(pOpt)
        }
      }
    }

    options = _.sortBy(options, 'value')

    return (
      <FormRateCardAutoComplete
        label='project.viewBudget.timeActivity'
        name='title'
        autoFocus
        validations={['required']}
        value={item.title}
        displayValue={item.title}
        options={options}
        onChange={this._onChangeInput.bind(this, 'title')}
        onBlur={this._onBlurInput.bind(this, 'title')}
        onKeyDown={this._onKeyDownInput.bind(this, 'title')}
        onSelect={this._onSelectRatecard.bind(this)}
        hideAdd
        showOptionIcon
        showSelection={!!(options && options.length > 0)}
        hasAutoSelect={false}
      />
    )
  }

  /* Event handlers */
  _onChangeInput = (name, value, ev) => {
    const { item, onChange } = this.props

    if (onChange) {
      onChange(item.id, name, value, ev)
    }
  }

  _onBlurInput = (name, ev) => {
    const { item, onSave } = this.props

    if (onSave) {
      onSave(item.id, name, ev)
    }
  }

  _onSelectRatecard = (ratecard, ev) => {
    const { item, onSelectRatecard } = this.props

    if (onSelectRatecard) {
      onSelectRatecard(item.id, ratecard, ev)
    }
  }

  _onKeyDownInput = (name, ev) => {
    const { item, onKeyDown } = this.props

    if (onKeyDown) {
      onKeyDown(item.id, name, ev)
    }
  }

  _onDeleteActivity = () => {
    const { item, onDelete } = this.props

    if (onDelete) {
      onDelete(item.id)
    }
  }

  _onEditActivity = () => {
    const { item, onEdit } = this.props

    if (onEdit) {
      onEdit(item.id)
    }
  }

  _onAddActivity = type => {
    const { item, onAddActivity } = this.props

    if (onAddActivity) {
      onAddActivity(item, type)
    }
  }

  _onClickEditInput = name => {
    const { item, onClickEdit } = this.props

    if (onClickEdit) {
      onClickEdit(item.id, name)
    }
  }

  _defaultDragRender (node) {
    return node
  }

  _isDragging () {
    const { item, dragItem } = this.props

    if (dragItem && dragItem.item && dragItem.item.id === item.id) {
      return true
    }

    return false
  }
}

const WithDragSource = dropTarget(
  _props => 'all',
  itemTarget,
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  })
)(
  dragSource(
    _props => 'all',
    itemSource,
    (connect, monitor) => ({
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging(),
      dragItem: monitor.getItem()
    })
  )(ActivityItem)
)

export { WithDragSource }

export default ActivityItem
